import { Vortex } from 'react-loader-spinner';

export const Loader = () => {
  return (
    <div>
      <Vortex />
    </div>
  );
};
